import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../../context/ThemeContext";
import { Notice, Page } from "../components/ui";
import LossesCard from "../components/LossesCard";
import { currentMonth, shiftMonth } from "../lib/format";
import { ui } from "../theme";

// Flujo → Pérdidas (C): el dinero que salió y no dejó nada. Es parte del
// gasto, no un egreso aparte: la nómina pagada sin horas que la justifiquen y
// los gastos marcados como pérdida (el motivo se pone al editar el gasto).

const RANGES = [6, 12, 24];

export default function LossesSection() {
  const { t } = useTranslation("common");
  const { isDarkMode } = useTheme();
  const c = ui(isDarkMode);
  const navigate = useNavigate();
  const [months, setMonths] = useState(12);
  const to = currentMonth();
  const from = shiftMonth(to, -(months - 1));

  return (
    <Page
      title={t("expenses.menu.losses")}
      subtitle={t("expenses.lossesPage.subtitle")}
      actions={
        <>
          <select aria-label={t("expenses.summary.range")} className={`${c.inputBase} w-auto`} value={months} onChange={(e) => setMonths(Number(e.target.value))}>
            {RANGES.map((r) => (
              <option key={r} value={r}>
                {t("expenses.summary.lastMonths", { count: r })}
              </option>
            ))}
          </select>
          <button type="button" className={c.secondary} onClick={() => navigate("/expenses/expenses")}>
            <i className="ri-receipt-line mr-1" />
            {t("expenses.lossesPage.markExpense")}
          </button>
        </>
      }
    >
      <Notice tone="info">{t("expenses.lossesPage.explain")}</Notice>
      <LossesCard from={from} to={to} />
    </Page>
  );
}
